// removed by extract-text-webpack-plugin
module.exports = {"Website":"Website","editMask":"editMask","isEdit":"isEdit"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Website/Website.scss
// module id = D/tK
// module chunks = 0